module.exports = __webpack_public_path__ + "static/media/caution.0afe798c.svg";